/* eslint-disable react/no-string-refs */
import React from 'react';
import { PropTypes as PT } from 'prop-types';
import _compact from 'lodash/compact';
import { ReactComponent as CancelIcon } from '@lifesize/ux-assets/vectors/svgIcons/cancel.svg';
import { SETTINGS_MODAL } from 'constants/SettingsModal';
import { CONTACT_MODAL } from 'constants/ContactModal';
import { START_CALL_MODAL } from 'constants/StartCallModal';
import { JOIN_MODAL } from 'constants/JoinModal';
import classes from './FullScreenModal.module.scss';

/**
 * This class is used as the holding component for all full screen modals
 * in the app. We just perform a simple switch on the subcomponent type to be
 * rendered in the full screen modal.
 */
export class FullScreenModal extends React.Component {
  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = (event) => {
    if (event.keyCode === 27) {
      this.props.onCloseClicked(this.props.visibleComponent);
    }
  };

  renderNotification() {
    const { message } = this.props;
    return (
      <div className={classes.notificationContainer}>
        <div
          id={!message ? 'hiddenNotification' : 'visibleNotification'}
          className={`${classes.notification} ${!message ? classes.hidden : ''}`}
        >
          {message}
        </div>
      </div>
    );
  }

  render() {
    const fullHeightModalList = [SETTINGS_MODAL, START_CALL_MODAL];
    const modalContentClasses = _compact([
      classes.modalContent,
      fullHeightModalList.indexOf(this.props.visibleComponent) !== -1 ? classes.fullHeight : '',
      this.props.visibleComponent === CONTACT_MODAL || this.props.visibleComponent === JOIN_MODAL
        ? classes.noPadding
        : '',
      this.props.visibleComponent === this.props.internalModals.OFFLINE_MODAL ? classes.fullScreen : ''
    ]).join(' ');

    return this.props.visibleComponent ? (
      <div
        id="displayedFullScreenModal"
        className={classes.container}
        onClick={() => {
          if (!this.props.nonDismissable) {
            this.props.onCloseClicked(this.props.visibleComponent);
          }
        }}
        style={{ zIndex: this.props.priority }}
      >
        <div
          className={modalContentClasses}
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          {!this.props.disableCloseButton ? (
            <button
              ref="closeModalButton"
              id="closeModalButton"
              className={classes.closeButton}
              aria-label="Close Full Screen Modal"
              onClick={() => {
                this.props.onCloseClicked(this.props.visibleComponent);
              }}
              data-testid="closeModalButton"
            >
              <CancelIcon data-testid="cancelIcon" />
            </button>
          ) : null}

          {this.renderNotification()}
          {this.props.children}
        </div>
      </div>
    ) : null;
  }
}

FullScreenModal.propTypes = {
  children: PT.element.isRequired,
  disableCloseButton: PT.bool,
  message: PT.string,
  onCloseClicked: PT.func.isRequired,
  visibleComponent: PT.string,
  nonDismissable: PT.bool,
  internalModals: PT.object,
  priority: PT.number
};

FullScreenModal.defaultProps = {
  internalModals: {}
};

export default FullScreenModal;
